import fr from 'facet-rest';

const tableHiddenFields = [
  'householdId',
];

export const MeetingSummaryTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride(tableHiddenFields, { hidden: true })
  .nameOverride('start', { ordinal: 0, _formatString: 'MM/DD/YYYY hh:mmA', _displayTime: true })
  .nameOverride('clientName', { ordinal: 1 })
  .nameOverride('bestNextSteps', { ordinal: 2 })
  .nameOverride('meetingType', { ordinal: 3 });

export const getMeetingSummaryFilters = () => [
  {
    name: 'agentId', // picklist
    query: 'getMeetingSummaryByAgentID',
    prompt: 'Assigned To',
  },
];

export const MeetingSummaryEditOverride = fr.metaOverride();
